import { Component, input, computed, inject } from '@angular/core';
import { TrajetDto } from '../../dto/trajet.dto';
import { ParametrageService } from '../../services/parametrage.service';

@Component({
	selector: 'app-affichage-depart-arrivee',
	templateUrl: './affichage-depart-arrivee.component.html',
	styleUrl: './affichage-depart-arrivee.component.scss'
})
export class AffichageDepartArriveeComponent {
	// Injections
	private readonly parametrageService = inject(ParametrageService);

	// Inputs
	trajet = input.required<TrajetDto>();

	// Computed
	adresseArrivee = computed(() => this.trajet().adresseArrivee);
	adresseDepart = computed(() => this.trajet().adresseDepart);
	dateArrivee = computed(() => this.trajet().dateArrivee);
	dateDepart = computed(() => this.trajet().dateDepart);
	lieuArrivee = computed(() => this.trajet().nomLieuArrivee);
	lieuDepart = computed(() => this.trajet().nomLieuDepart);

	/**
	 * Génère un lien Google Maps pour une adresse donnée.
	 *
	 * @param adresse l'adresse à rechercher.
	 * @returns le lien Google Maps ou null.
	 */
	lienGoogleMaps(adresse: string | null | undefined): string | null {
		const base = this.parametrageService.lienGoogleMaps();
		if (!adresse || !base) return null;
		return `${ base }${ encodeURIComponent(adresse) }`;
	}
}
